//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import {
  IContentDetailMediaRequest,
  IContentDetailMediaResponse,
} from '@apis/content-detail/contentDetailApiModels';
import { sessionFetch } from '@utils/sessionFetch';

const contentDetailFetch = (endpoint: string, init?: RequestInit): Promise<Response> => {
  return sessionFetch(`/api/content-detail${endpoint}`, init);
};

/**
 * Gets content detail content per the given request params
 *
 * /api/content-detail/content
 */
export const getContent = async (
  request: IContentDetailMediaRequest,
): Promise<IContentDetailMediaResponse> => {
  const params = $.param({
    ...request,
    // This id is a 'required' param, but isn't actually used
    // for mentions requests. Just send 'mention' here as a workaround.
    id: request.id ?? 'mention',
  });
  const res = await contentDetailFetch(`/content?${ params }`);
  return res.json();
};
